import { Stack } from '@mui/material';
import { observer } from 'mobx-react-lite';
import { useEffect } from 'react';
import { useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import {
  ControlledTextField,
  ControlledMaskedTextField,
  RequiredIndicator,
  TCPA,
} from '@components';
import { useStore } from '@stores';

import { PassthroughParams } from '../contactInfo/PassthroughParams';

export const CompactContactInfoSubModule = observer(() => {
  const { t: tName } = useTranslation('subModules/name');
  const { t: tContact } = useTranslation('subModules/contactInfo');
  const { t: tZip } = useTranslation('subModules/zipCode');
  const { getValues, setValue } = useFormContext();

  const name =
    (getValues('firstName') ?? '') + ' ' + (getValues('lastName') ?? '');

  useEffect(() => {
    setValue('fullName', name);
  }, [name, setValue]);

  const { utilityStore } = useStore();

  useEffect(() => {
    if (utilityStore.state) {
      setValue('state', utilityStore.state);
    }
  }, [utilityStore.state, setValue]);

  return (
    <div>
      <RequiredIndicator />
      <ControlledTextField
        label={tName('FirstNameLabel')}
        placeholder="John"
        fieldName="firstName"
        data-testid="firstNameTestId"
        data-tf-sensitive="false"
        required
      />

      <ControlledTextField
        label={tName('LastNameLabel')}
        placeholder="Smith"
        fieldName="lastName"
        data-testid="lastNameTestId"
        data-tf-sensitive="false"
        required
      />

      <ControlledTextField
        label={tContact('email')}
        placeholder={tContact('emailPlaceholder')}
        fieldName="email"
        inputMode="email"
        data-testid="emailTestId"
        data-tf-sensitive="false"
        required
      />

      <ControlledMaskedTextField
        label={tContact('phone')}
        placeholder="(123)456-7890"
        maskType="phone"
        inputMode="tel"
        labelStyle="inner"
        fieldName="phone"
        data-testid="mobileTestId"
        data-tf-sensitive="false"
        required
      />

      <ControlledTextField
        fieldName="zipCode"
        placeholder="00000"
        data-testid="zipCodeSubModule"
        label={tZip('placeholder')}
        inputMode="numeric"
        required
      />

      <Stack spacing={1.5} mt={1}>
        <TCPA />
        <PassthroughParams />
      </Stack>
    </div>
  );
});
